<template>
	<div class="bg-red-800">
		<div class="justify-center max-w-6xl md:px-6 mx-auto">
			<div class="flex flex-col text-center text-white">
				<div class="p-4">
					<p class="font-bold text-2xl">Our Services</p>
					<p class="pt-4">
						Our smartly uniformed, professional fleet of trade plate drivers have vast experience within the prestige market place and can assist you with direct dealer transfers of new or used stock as well as collection and delivery to and from, private customers, auction centres, shipping ports and lease companies
					</p>
				</div>
			</div>
		</div>
	</div>
	<div class="bg-gray-100 py-2">
		<div class="justify-center max-w-6xl md:px-6 mx-auto">
			<ServiceTile
				:imageName="tiles[0].imageName"
				:title="tiles[0].title"
				:text="tiles[0].text"
			/>
		</div>
	</div>
	<div class="justify-center max-w-6xl md:px-6 mx-auto">
		<ServiceTile
			:imageName="tiles[1].imageName"
			:title="tiles[1].title"
			:text="tiles[1].text"
		/>
	</div>
	<div class="bg-gray-100 py-2">
		<div class="justify-center max-w-6xl md:px-6 mx-auto">
			<ServiceTile
				:imageName="tiles[2].imageName"
				:title="tiles[2].title"
				:text="tiles[2].text"
			/>
		</div>
	</div>
</template>

<script>
import ServiceTile from '@/components/ServiceTile.vue'

export default {
	name: 'Services',
	components: {
		ServiceTile,
	},
	data: function() {
		return {
			tiles: [
				{
					imageName: 'customer-deliveries.jpg',
					title: 'Customer Collections & Deliveries',
					text: [
						'We strive to ensure that the good relationships that you build with your customers are continued through our exemplary delivery service.',
						'We appreciate that our drivers are sometimes the only impression that an end user will have of their vehicle supplier and look forward to professionally representing dealerships in the final part of the sales process.',
						'With our extensive product knowledge we are happy to carry out delivery of demonstrators and complete new or pre-owned vehicle hand-overs.',
					],
				},
				{
					imageName: 'services2.jpg',
					title: 'Direct Dealer Transfers',
					text: [
						'Recognised by many in the dealership network we have good personal working relationship with numerous sales managers and dealer principals from a number of big groups and smaller retailers.',
						'We carry out vehicle movements using our carefully selected fleet of drivers. On collection of any vehicle our drivers perform a full bodywork and interior appraisal and record this on our inspection forms to ensure every vehicle arrives at its new destination in the same condition.',
					],
				},
				{
					imageName: 'services3.jpg',
					title: 'Corporate Customer Deliveries',
					text: [
						'We are involved on a daily basis with an established network of corporate fleet operators completing hand-overs of new vehicles uk wide.',
						'We always offer the same high standard of service to fleet customers as to retail customers and will tailor the handover requirements accordingly, providing a full demonstration of the controls and features including any Sat-Nav equipment, Bluetooth connectivity etc.',
						'We appreciate that the signing of paperwork and lease documents is particularly important and ensure that everything returns to our office where copies are scanned to you immediately by email and originals returned by post the following day.',
					],
				},
			]
		};
	},
}

</script>